import React from 'react';
import { css } from '@emotion/react';
import { Grid, TextField, MenuItem } from '@material-ui/core';
import { OnwardCheckbox } from '@/components/ShipmentForm/blocks';
import { Image } from 'react-bootstrap';
import { Body1, Header1, ItemCheckbox } from '../../Crossdocking/blocks';
import FileDropZone from '../../FileDropZone';

const Default = ({ exception, required, order, callbacks }) => {
    return (
        <>
            <Grid
                container
                css={css`
                    margin-bottom: 30px;
                `}
            >
                <TextField
                    select
                    variant="outlined"
                    label="Quantity (required)"
                    value={exception.quantity}
                    onChange={(e) => {
                        callbacks.setException((prev) => ({
                            ...prev,
                            quantity: e.target.value,
                        }));
                    }}
                    fullWidth
                >
                    {Array.from({ length: 10 }, (_, i) => i + 1).map((value) => (
                        <MenuItem key={value} value={value}>
                            {value}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
            <Grid
                direction="row"
                container
                css={css`
                    margin-bottom: 30px;
                `}
            >
                <TextField
                    variant="outlined"
                    label="Description (required)"
                    name="desc"
                    fullWidth
                    value={exception.notes || ''}
                    onChange={(e) =>
                        callbacks.setException((prev) => ({
                            ...prev,
                            notes: e.target.value,
                        }))
                    }
                    multiline
                    rows={1}
                />
            </Grid>
            <Grid
                direction="row"
                container
                css={css`
                    margin-bottom: 8px;
                `}
            >
                <Body1>
                    Image
                    {required.includes('images') ? (
                        <Body1
                            css={css`
                                color: #d32f2f;
                            `}
                        >
                            &nbsp;(required)
                        </Body1>
                    ) : (
                        ''
                    )}
                </Body1>
            </Grid>
            <Grid
                container
                direction="row"
                css={css`
                    margin-bottom: 8px;
                `}
            >
                {(exception.images || []).map((image) => (
                    <a href={image} target="_blank">
                        <Image
                            css={css`
                                height: 100px;
                                width: 100px;
                            `}
                            src={image}
                        />
                    </a>
                ))}
                <FileDropZone handleFileAdd={callbacks.handleFileAdd} type="multi" />
            </Grid>
        </>
    );
};

export default Default;
